import React from 'react';
import DocumentName from './DocumentName';

const TableContent = ({
  key1,
  val1,
  doc2Visibility,
  tbodyStyle,
  trStyle,
  thStyle,
  tdValueStyle,
  verticalLabel,
  containsPropVal,
  tdPropStyle,
  findDocNumber,
  data,
  comparisonID,
  setDoc1Name,
  setDoc2Name,
  doc1Name,
  doc2Name
}) => {
  return (
    <tbody style={tbodyStyle} key={key1}>
      {Object.entries(val1).slice(0, 1).map(([key2, val2]) => {
        const totalEntry = Object.entries(val1).find(([key]) => key.toLowerCase() === 'total');
        
        return (
          <tr style={trStyle} key={key2}>
            <th style={{...thStyle, display: "flex", justifyContent: "space-between", alignItems: "center", width:'90%' }}>
              <span title={key2 + ": " + val2}>
                {doc2Visibility[key1]
                  ? `${key2}: ${val2}`  
                  : `${key2.length > 20 ? key2.substring(0, 20) + "..." : key2}` + 
                    `: ${val2.length > 30 ? val2.substring(0, 30) + "..." : val2}`
                }
              </span>

              {!doc2Visibility[key1] && totalEntry && (
                <span style={{ fontWeight: "bold", textAlign: "right"}}>
                  <span style={{ color: "#00B3B5" }}>Total:</span> 
                  <span style={tdValueStyle}>{totalEntry[1]}</span>
                </span>
              )}
            </th>
          </tr>
        );
      })}
      
      {doc2Visibility[key1] && (
        <tr key={key1} style={trStyle}>
          <th style={verticalLabel}>
            {findDocNumber(key1)}
            <DocumentName 
              isDoc1={findDocNumber(key1)}
              data={data}
              comparisonID={comparisonID}
              setDoc1Name={setDoc1Name}
              setDoc2Name={setDoc2Name}
              doc1Name={doc1Name}
              doc2Name={doc2Name}
            />
          </th>
          {Object.entries(val1).slice(1).map(([key2, val2]) => (
            <td style={containsPropVal} key={key2}>
              <td style={tdPropStyle}>{key2}</td>
              <td style={tdValueStyle}>{val2}</td>
            </td>
          ))}
        </tr>
      )}
    </tbody>
  );
};

export default TableContent;
